@if (cardNameToShow == 'visa') {
<img src='assets/icons/cards/visa.svg' alt="{{ 'shared.icon' | transloco }}" class="w-full h-full object-cover">
}
@else if (cardNameToShow == 'mastercard') {
<img src='assets/icons/cards/mastercard.svg' alt="{{ 'shared.icon' | transloco }}" class="w-full h-full object-cover">
}
@else {
<img src='assets/icons/cards/card.svg' alt="{{ 'shared.icon' | transloco }}" class="w-full h-full object-cover">
}